var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasNodes
        ? _vm._l(_vm.nodes, function (node, idx) {
            return _c(
              "ul",
              {
                key: `list-group-${node?.id ?? "1"}-${idx}`,
                staticClass: "list-group list-group-flush",
              },
              [
                _c("li", { staticClass: "list-group-item" }, [
                  _vm._v(_vm._s(node.name)),
                ]),
                _vm._v(" "),
                node.children
                  ? _c(
                      "ul",
                      { staticClass: "list-group list-group-flush" },
                      _vm._l(node.children, function (child, idxChild) {
                        return child.url || child.filename
                          ? _c(
                              "a",
                              {
                                key: `list-group-item-${
                                  child?.id ?? "1"
                                }-${idxChild}`,
                                staticClass: "list-group-item",
                                attrs: {
                                  href: child.url
                                    ? child.url
                                    : _vm.getFormatUrlAPI(child.filename),
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(child.name) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            )
          })
        : _vm.showEmptyMessage
        ? [
            _c(
              "div",
              {
                staticClass: "text-center alert",
                class: _vm.classEmptyMessage,
                attrs: { role: "alert" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t(_vm.emptyMessage)) +
                    "\n        "
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }